"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyles = void 0;
var react_1 = __importStar(require("react"));
var core_1 = require("@material-ui/core");
var styles_1 = require("@material-ui/core/styles");
var html_react_parser_1 = __importDefault(require("html-react-parser"));
var react_intl_1 = require("react-intl");
var constants_1 = require("../../constants");
var NotificationsContext_1 = require("../../context/NotificationsContext");
var NotificationCardHeader_1 = __importDefault(require("../notification-card-header/NotificationCardHeader"));
var NotificationCardFooter_1 = __importDefault(require("../notification-card-footer/NotificationCardFooter"));
exports.useStyles = styles_1.makeStyles(function (theme) {
    var notificationsPanel = theme.variables.palette.notificationsPanel;
    var card = notificationsPanel.card;
    return {
        paperContainer: {
            borderRadius: 4,
        },
        card: {
            borderRadius: 4,
            marginTop: theme.spacing(3),
            padding: theme.spacing(3) + "px",
            background: function (_a) {
                var viewed = _a.viewed;
                return (viewed ? card.background : card.hover);
            },
            boxShadow: 'none',
            position: 'relative',
            '&:hover': {
                background: card.hover,
            },
        },
        message: {
            display: function (_a) {
                var open = _a.open;
                return (open ? "block" : '-webkit-box');
            },
            '-webkit-box-orient': 'vertical',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            fontSize: 13,
            whiteSpace: 'normal',
            '-webkit-line-clamp': function (_a) {
                var open = _a.open;
                return (open ? 'none' : 2);
            },
            height: function (_a) {
                var open = _a.open;
                return (open ? 'auto' : constants_1.defaultMessageHeight + "px");
            },
            lineHeight: constants_1.defaultMessageHeight + "px",
            transition: theme.transitions.create('height', {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.enteringScreen,
            }),
        },
        elementWrapper: {
            paddingBottom: theme.spacing(3),
        },
    };
});
var NotificationCard = function (props) {
    var notification = props.notification;
    var intl = react_intl_1.useIntl();
    var subjectMessage = notification.subjectMessage, bodyMessage = notification.bodyMessage, viewed = notification.viewed, created = notification.created, id = notification.id;
    var toggleViewed = react_1.useContext(NotificationsContext_1.NotificationsContext).toggleViewed;
    var _a = react_1.useState(false), isOpen = _a[0], setIsOpen = _a[1];
    var _b = react_1.useState(false), needSubjectCollapse = _b[0], setNeedSubjectCollapse = _b[1];
    var _c = react_1.useState(false), needMessageCollapse = _c[0], setNeedMessageCollapse = _c[1];
    var classes = exports.useStyles({ open: isOpen, viewed: viewed });
    var bodyMessageRef = react_1.useRef(null);
    react_1.useEffect(function () {
        if (!bodyMessageRef || !bodyMessageRef.current) {
            return;
        }
        var _a = bodyMessageRef.current, scrollHeight = _a.scrollHeight, clientHeight = _a.clientHeight;
        setNeedMessageCollapse(scrollHeight !== clientHeight);
    }, [bodyMessageRef, setNeedMessageCollapse]);
    var toggleMessage = react_1.useCallback(function () {
        setIsOpen(function (open) { return !open; });
        if (!isOpen && !viewed) {
            toggleViewed(id, true);
        }
    }, [id, isOpen, viewed, setIsOpen, toggleViewed]);
    var parsedBodyMessage = react_1.useMemo(function () { return html_react_parser_1.default(bodyMessage); }, [bodyMessage]);
    var parsedSubjectMessage = react_1.useMemo(function () {
        return html_react_parser_1.default(subjectMessage || intl.formatMessage({ id: 'noSubject' }));
    }, [subjectMessage, intl]);
    return (react_1.default.createElement(core_1.Box, { className: classes.card + " notification-card" },
        react_1.default.createElement("div", { className: classes.elementWrapper },
            react_1.default.createElement(NotificationCardHeader_1.default, { subjectMessage: parsedSubjectMessage, viewed: viewed, isOpen: isOpen, id: id, setNeedSubjectCollapse: setNeedSubjectCollapse })),
        react_1.default.createElement("div", { className: classes.elementWrapper },
            react_1.default.createElement(core_1.Typography, { ref: bodyMessageRef, variant: "body2", className: classes.message + " notification-card__text" }, parsedBodyMessage)),
        react_1.default.createElement(NotificationCardFooter_1.default, { isOpen: isOpen, needCollapse: needMessageCollapse || needSubjectCollapse, toggleMessage: toggleMessage, created: created })));
};
exports.default = NotificationCard;
